// extracted by mini-css-extract-plugin
module.exports = {"header":"subheader__header1Le","header--normal-weight":"subheader__header--normal-weighti4U"};